import ProductData from "@/http/data/product-data";

export default class ProductState {
    isInitialized = false;
    products: ProductData[] = [];
}